import { Component } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddMemberComponent } from '../add-member/add-member.component';
import { ActivatedRoute } from '@angular/router';
import { ThemeserviceService } from '../theme/themeservice.service';
import { MemberInsurerServiceService } from '../../services/member-insurer-service.service';
import { Roles } from '../../models/commonmodel';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { AgentCardComponent } from "../agent-card/agent-card.component";
import {
  trigger,
  transition,
  query,
  style,
  stagger,
  animate
} from '@angular/animations';
import { AddMedicalProviderComponent } from '../add-medical-provider/add-medical-provider.component';
import { MemberInsurerRestService } from '../../services/member-insurer-rest.service';
import { LoaderComponent } from "../shared/loader/loader.component";
import { NoDataFoundComponent } from "../shared/no-data-found/no-data-found.component";
import { ProviderCardComponent } from "../provider-card/provider-card.component";
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { InsurerAgent, masterProvider } from '../../models/phase1models';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppAgentTableViewComponent } from "../app-agent-table-view/app-agent-table-view.component";
import { ViewModeToggleComponent } from "../shared/components/view-mode-toggle/view-mode-toggle.component";
import { ConfirmationmodalComponent } from '../shared/components/confirmationmodal/confirmationmodal.component';
import { NotificationService } from '../shared/services/notifications.service';
// import { timeStamp } from 'console';
export type AgentFilterState = 'all' | 'active' | 'inactive';
@Component({
  selector: 'app-admindashboard',
  standalone: true,
  imports: [MatSlideToggleModule, CommonModule, MatTabsModule, AgentCardComponent, LoaderComponent, NoDataFoundComponent, ProviderCardComponent,
    MatFormFieldModule, FormsModule, MatInputModule, MatTooltipModule, AppAgentTableViewComponent, ViewModeToggleComponent],
  templateUrl: './admindashboard.component.html',
  styleUrl: './admindashboard.component.scss',
  animations: [
    trigger('listAnimation', [
      transition('* => *', [ // each time the binding value changes
        query(':enter', [
          style({ opacity: 0, transform: 'translateY(20px)' }),
          stagger(100, [ // delay between each card
            animate('400ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
          ])
        ], { optional: true })
      ])
    ])
  ]
})


export class AdmindashboardComponent {
statusUpdateFalse(agentInfo: any) {
  const dialogConfig = new MatDialogConfig();
      dialogConfig.width = '350px';
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = false;
  
      const dialogRef = this.dialog.open(ConfirmationmodalComponent, dialogConfig);
      dialogRef.componentInstance.title = 'Confirm';
      dialogRef.componentInstance.mode = 'Add';
      dialogRef.componentInstance.message = 'Are you sure you want to update the status?';
  
      dialogRef.afterClosed().subscribe((isConfirmed: boolean) => {
        if (isConfirmed) {
          this.restService.updateAgentStatus(agentInfo.userId, false).subscribe({
            next: (response: string) => {
              this.notificationService.showNotification('Status updated sucessfully');
              this.memberService.setrefreshAgents();
            },
            error: (error) => {
              const message = error?.error?.message || 'An error occurred during status update.';
              this.notificationService.showNotification(message, 'error');
            }
          });
        }
      }
      )

}
statusUpdateTrue(agentInfo: any) {
  const dialogConfig = new MatDialogConfig();
      dialogConfig.width = '350px';
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = false;
  
      const dialogRef = this.dialog.open(ConfirmationmodalComponent, dialogConfig);
      dialogRef.componentInstance.title = 'Confirm';
      dialogRef.componentInstance.mode = 'Add';
      dialogRef.componentInstance.message = 'Are you sure you want to update the status?';
  
      dialogRef.afterClosed().subscribe((isConfirmed: boolean) => {
        if (isConfirmed) {
          this.restService.updateAgentStatus(agentInfo.userId, true).subscribe({
            next: (response: string) => {
              this.notificationService.showNotification('Status updated sucessfully');
              this.memberService.setrefreshAgents();
            },
            error: (error) => {
              const message = error?.error?.message || 'An error occurred during status update.';
              this.notificationService.showNotification(message, 'error');
            }
          });
        }
      }
      )

}
openeditForm(row: any) {
 const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '750px';
    dialogConfig.height = '550px';
    dialogConfig.data = row;
    console.log("the agent data is" + row)
    this.dialog.open(AddMemberComponent, dialogConfig)
}

  searchQuery: string = '';
  length: any;

  isprovider: boolean = false;
  urlmap: any;
  isSidebarExpanded = false;
  role = this.memberService.getLoginUserRole();
  enumRole = Roles;
  agentsList: InsurerAgent[] = [];
  agentListPagination:InsurerAgent[]=[];
  distributorListPagination:any[]=[];
  distributorList: any[] = []
  distributorListtemp: any[] = [];
  agentsListTemp: InsurerAgent[] = [];
  providerList: InsurerAgent[] = [];
  providerTemp: InsurerAgent[] = [];
  isDataLoading: boolean = false;
  currentState: AgentFilterState = 'all';
  InsurerAgentColumns:string[]=['Name','Yrs of Experience','Address','Phone','Email','Status','Actions'];
  providerAgentColumns:string[]=['Name','Yrs of Experience','Mapped Provider','Phone','Email','Status','Actions'];
  DistributorAgentColumns:string[]=['Name' ,'Activation Start Date','Mapped Insurer','Phone','Email','Status','Actions']



  selectedTab = 0;
  tabs = [
    { label: 'View Agents', count: 0 },
    { label: 'View Providers', count: 0 },
    { label: 'View Distributor', count: 0 }
  ];

  constructor(private dialog: MatDialog, private router: ActivatedRoute, private theme: ThemeserviceService,
    private memberService: MemberInsurerServiceService, private restService: MemberInsurerRestService,private  notificationService :NotificationService
  ) {

    this.memberService.refreshAgents$.subscribe(() => {
      if (this.role != this.enumRole.DISTRIBUTOR)
        this.getAgents();
      else
        this.getDistributorAgents()

    });

    this.memberService.refreshProviders$.subscribe(() => {
      this.getProviderAgents()
    });

  }

  
changeViewMode(mode: 'list' | 'grid') {
    this.viewMode = mode;
  }
viewMode: 'grid' | 'list' = 'grid';

  currentPage = 1;
  itemsPerPage = 6;
  totalPages = 1;

  selectedFilter: 'all' | 'active' | 'inactive' = 'all';
  applyFilter(filterType: 'all' | 'active' | 'inactive'): void {
    this.selectedFilter = filterType;
    console.log(this.selectedTab +" "  + typeof(this.selectedFilter))
    if(this.selectedTab==2){
    if (this.selectedFilter == 'active')
      this.distributorList = this.distributorListtemp.filter(value => {
        value.isactive === true
      })
    else if (this.selectedFilter === "inactive")

      this.distributorList = this.distributorListtemp.filter(value => {
        value.isactive === false
      })
    else {
      this.distributorList = [...this.distributorListtemp]
    }}


    else if(this.selectedTab===0){
      console.log(this.selectedFilter)

      if (this.selectedFilter=='active'){
        this.agentsList = this.agentsListTemp.filter(value=> {
        value.isactive
      
      })}
      
    else if (this.selectedFilter==='inactive'){

       this.agentsList = this.agentsListTemp.filter(value => {
        !value.isactive 
      })
    console.log(this.agentsList)}
    else  { 
       this.agentsList = [...this.agentsListTemp]
    }

    }

  }

  ngOnInit() {
    console.log(this.memberService.getLoginUserRole())
    const role =this.memberService.getLoginUserRole();

    if(role==='INSURER'){
      this.selectedTab=0;
      this.getAgents()
    }
    else if(role==='PROVIDER'){
      this.selectedTab=1;
      this.getAgents()
    }
    else if(role==='DISTRIBUTOR'){
      this.selectedTab=2;
      this.getDistributorAgents()
    }


    if (this.role != this.enumRole.DISTRIBUTOR)
      this.selectedTab=0
      // this.getAgents();

    if (this.role == this.enumRole.PROVIDER)
      this.selectedTab = 1;
    this.filterProviders();
    // this.getProviderAgents()

    if (this.role == this.enumRole.DISTRIBUTOR) {
      this.selectedTab = 2;
      // this.getDistributorAgents();
    }


    if (this.role == this.enumRole.INSURER)
      // this.getProviders();
    this.filterAgents();


    this.memberService.sidebarExpanded$.subscribe((expanded) => {
      if (expanded) {
        this.isSidebarExpanded = false;
      } else {
        this.isSidebarExpanded = true;
      }
    });
    this.length = this.agentsList.length;
  }

  selectState(state: AgentFilterState): void {
    
    console.log(this.selectedTab)
    // if (this.currentState === state) {
    //   return;
    // }
    this.currentState = state;
    if (this.selectedTab===0) {
      this.filterAgents();
    } else if (this.selectedTab === 1) {

        
  
       this.filterProviders();
    }
    else if (this.selectedTab === 2) {
      this.filterDistributors();
    }
  }

  filterAgents(): void {
  
    console.log(this.currentState)
    console.log(this.agentsListTemp)
    switch (this.currentState) {
      case 'active':
        this.agentListPagination= this.agentsListTemp.filter(agent => agent.isactive == true);
        console.log(this.agentsList)
           if (this.agentListPagination.length > 0) {
       this.calculateTotalPages(this.agentListPagination);
       this.currentPage = 1;
       this.updateVisibleItems(this.agentListPagination);
     }
    
        break;
      case 'inactive':
        this.agentListPagination = this.agentsListTemp.filter(agent => agent.isactive == false);
        console.log(this.agentListPagination)
             if (this.agentListPagination.length > 0) {
       this.calculateTotalPages(this.agentListPagination);
       this.currentPage = 1;
       this.updateVisibleItems(this.agentListPagination);
     }
    
        break;
      case 'all':
      default:
        this.agentListPagination = [...this.agentsListTemp];
          this.calculateTotalPages(this.agentListPagination);
       this.currentPage = 1;
       this.updateVisibleItems(this.agentListPagination);
        
       
     break;
    }

   
   
  }
  goToPage(page: number): void {
    
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
       if(this.selectedTab===0 || this.selectedTab===1){
      this.updateVisibleItems(this.agentListPagination);}
      else{
        this.updateVisibleItems(this.distributorListPagination)
      }
    }
  }

  filterProviders(): void {
    
    // switch (this.currentState) {
    //   case 'active':
    //     this.agentsList = this.agentsListTemp.filter(provider => provider.isactive === true);
    //     if(this.agentsList.length>0){
    //       this.calculateTotalPages(this.agentsList);
    //       this.currentPage=1;
    //       this.updateVisibleItems()
    //     }
        
    //     break;
    //   case 'inactive':
    //     this.agentsList = this.agentsListTemp.filter(provider => provider.isactive === false);
        
    //     break;
    //   case 'all':
    //   default:
    //     this.agentsList = [...this.agentsList];
    //     break;
    // }

    if(this.currentState==='active'){
      this.agentsList=this.agentsListTemp.filter(agent=>agent.isactive==true)
  
    }
    else if(this.currentState==='inactive'){
      this.agentsList=this.agentsListTemp.filter(agent=>!agent.isactive)

    }
    else if(this.currentState==='all'){
      this.agentsList=[...this.agentsListTemp]
    }
  }
  filterDistributors(): void {
    switch (this.currentState) {
      case 'active':
        this.distributorListPagination = this.distributorListtemp.filter(distributor => distributor.isactive === true);
        this.calculateTotalPages(this.distributorListPagination);
        this.currentPage=1;
        this.updateVisibleItems(this.distributorListPagination)
      
      
        
        break;
      case 'inactive':
        this.distributorListPagination = this.distributorListtemp.filter(distributor => distributor.isactive === false);
         this.calculateTotalPages(this.distributorListPagination);
        this.currentPage=1;
        this.updateVisibleItems(this.distributorListPagination)
        break;
      case 'all':
      default:
        this.distributorListPagination = [...this.distributorListtemp]
        this.calculateTotalPages(this.distributorListPagination);
        this.currentPage=1;
        this.updateVisibleItems(this.distributorListPagination)

    }
  }

  getDistributorAgents() {
    this.distributorList = [];
    this.distributorListtemp = [];
    this.isDataLoading = true;
    const id = this.memberService.getLoginUserId();
    // const id =this.memberService.getCreatedBy();

    console.log(id)
    this.restService.getAllDistributorAgentsList(id).subscribe({
      next: (response) => {
        console.log(response);


        if (response.length > 0) {
          const sorted = response.sort((c: { createdon: string | number | Date; }, d: { createdon: string | number | Date; }) => {
            const dateA = c.createdon ? new Date(c.createdon).getTime() : 0;
            const dateB = d.createdon ? new Date(d.createdon).getTime() : 0;

            // Push nulls to the bottom
            if (!c.createdon && !d.createdon) return 0;
            if (!c.createdon) return 1;
            if (!d.createdon) return -1;

            return dateB - dateA; // Descending order
          });

          this.distributorListtemp = sorted;
          this.currentPage = 1;
        }
        else {
          this.currentPage = 0;
        }
        console.log(this.distributorListtemp);
        this.calculateTotalPages(this.distributorListtemp);
        this.length = this.distributorListtemp.length
        console.log(this.length)
        this.updateVisibleItems(this.distributorListtemp);
        this.tabs[2].count = this.distributorListtemp.length;

        this.isDataLoading = false;

        // this.distributorList=response;
      }
    })

  }
  getProviderAgents(){
    this.providerList=[]
    this.isDataLoading=true;
    this.restService.getprovideragents().subscribe({
      next: (response: InsurerAgent[]) => {
        if (response.length > 0) {
          response = response
            .filter((member) => member.createdon)
            .sort(
              (a, b) =>
                new Date(b.createdon).getTime() - new Date(a.createdon).getTime()
            );
          this.providerTemp = response;
          this.currentPage = 1;
        }
        else {
          this.currentPage = 0;
        }
        this.calculateTotalPages(this.providerTemp);
        this.length = this.providerTemp.length
        this.updateVisibleItems(this.providerTemp); // paginate initial view
        this.tabs[1].count = this.providerTemp.length;
        this.isDataLoading = false;
      },
      error: () => {
        this.isDataLoading = false;
      },
    });
  }

  // getProviders() {
  //   this.providerList = [];
  //   this.isDataLoading = true;

  //   this.restService.getAllMasterMEPs().subscribe({
  //     next: (response: masterProvider[]) => {
  //       if (response.length > 0) {
  //         response = response
  //           .filter((member) => member.createdon)
  //           .sort(
  //             (a, b) =>
  //               new Date(b.createdon).getTime() - new Date(a.createdon).getTime()
  //           );
  //         this.providerTemp = response;
  //         this.currentPage = 1;
  //       }
  //       else {
  //         this.currentPage = 0;
  //       }
  //       this.calculateTotalPages(this.providerTemp);
  //       this.length = this.providerTemp.length
  //       this.updateVisibleItems(); // paginate initial view
  //       this.tabs[1].count = this.providerTemp.length;
  //       this.isDataLoading = false;
  //     },
  //     error: () => {
  //       this.isDataLoading = false;
  //     },
  //   });
  // }



  isRotating = false;

  onRefresh() {
    this.isRotating = true;

    if (this.selectedTab === 0) {
      this.getAgents();
    } else if (this.selectedTab === 1) {
      // this.getProviders();
      this.getProviderAgents()
    }
    else if (this.selectedTab === 2) {
      this.getDistributorAgents()
    }

    // Stop animation after 1s (match CSS animation duration)
    setTimeout(() => {
      this.isRotating = false;
    }, 500);
  }

  getAgents() {
    this.agentsList = [];
    this.agentsListTemp = [];
    this.isDataLoading = true;

    this.restService.getAllAgentList().subscribe({
      next: (response: InsurerAgent[]) => {
        if (response.length > 0) {
          const sorted = response.sort((a, b) => {
            const dateA = a.createdon ? new Date(a.createdon).getTime() : 0;
            const dateB = b.createdon ? new Date(b.createdon).getTime() : 0;

            // Push nulls to the bottom
            if (!a.createdon && !b.createdon) return 0;
            if (!a.createdon) return 1;
            if (!b.createdon) return -1;

            return dateB - dateA; // Descending order
          });

          this.agentsListTemp = sorted;
          this.currentPage = 1;

        }
        else {
          this.currentPage = 0;
        }
        console.log(this.agentsListTemp);
        this.length = this.agentsListTemp.length
        this.calculateTotalPages(this.agentsListTemp);
        this.updateVisibleItems(this.agentsListTemp);
        this.tabs[0].count = this.agentsListTemp.length;

        this.isDataLoading = false;
      },
      error: () => {
        this.isDataLoading = false;
      }
    });
  }


  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      if(this.selectedTab===0 || this.selectedTab===1){
      this.updateVisibleItems(this.agentsList);}
      else{
        this.updateVisibleItems(this.distributorList)
      }

    }
  }

  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
       if(this.selectedTab===0 || this.selectedTab===1){
      this.updateVisibleItems(this.agentsList);}
      else{
        this.updateVisibleItems(this.distributorList)
      }
    }
  }

  calculateTotalPages(list: any[]): void {
    
    this.totalPages = Math.ceil(list.length / this.itemsPerPage);
  }

  updateVisibleItems(list:any[]): any[]{
  
    const start = (this.currentPage - 1) * this.itemsPerPage;
    console.log(start)
    const end = start + this.itemsPerPage;
    console.log(end)
    console.log(this.agentsList)
    // this.currentPage++;

    if (this.selectedTab === 0) {
      return this.agentsList = list.slice(start, end);
    
    } else if (this.selectedTab === 1) {
     return this.agentsList =list.slice(start, end);
    
    }
    else if (this.selectedTab === 2) {
      return this.distributorList = list.slice(start, end);
      
    }
    return [];
  }

  searchExpanded = false;

  toggleSearch() {
    this.searchExpanded = !this.searchExpanded;
    if (!this.searchExpanded) {
      this.searchQuery = '';
      this.onSearch(); // reset search on close
    }
  }

  onSearch() {
    if (this.selectedTab == 0) {
      const query = this.searchQuery.trim().toLowerCase();
      if (!query) {
        this.agentsList = this.agentsListTemp; // Reset to full list if search is empty
        return;
      }
      this.agentsList = this.agentsListTemp.filter(row =>
        Object.values(row).some(val =>
          val && val.toString().toLowerCase().includes(query)
        )
      );
    }
    else if (this.selectedTab === 1) {
      const query = this.searchQuery.trim().toLowerCase();
      if (!query) {
        this.providerList = this.providerTemp; // Reset to full list if search is empty
        return;
      }
      this.providerList = this.providerTemp.filter(row =>
        Object.values(row).some(val =>
          val && val.toString().toLowerCase().includes(query)
        )
      );
    }
    else if (this.selectedTab === 2) {
      const query = this.searchQuery.trim().toLowerCase();
      if (!query) {
        this.distributorList = this.distributorListtemp; // Reset to full list if search is empty
        return;
      }
      this.distributorList = this.distributorListtemp.filter(row =>
        Object.values(row).some(val =>
          val && val.toString().toLowerCase().includes(query)
        )
      );

    }
  }

  // handleTabClick(index: number): void {
  //   this.selectedTab = index;
  //   this.currentPage = 1;
  //   this.onTabClick();
  //   const list = index === 0 ? this.agentsListTemp : this.providerTemp;
  //   this.calculateTotalPages(list);
  //   this.updateVisibleItems();
  // }

  onTabClick(): void {
    if (this.selectedTab === 0) {
      this.getAgents();
    } else {
      this.getProviderAgents()
    }
  }

  openAddProvider() {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '750px';
    dialogConfig.height = '600px';
    this.dialog.open(AddMedicalProviderComponent, dialogConfig)
  }

  openAddAgent() {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '750px';
    dialogConfig.height = '550px';
    dialogConfig.data = this.role;
    this.dialog.open(AddMemberComponent, dialogConfig)
  }
}
